<template>
  <div></div>
</template>

<script>
import api from "@/api";

export default {
  mounted() {
    this.getGeneralData();
  },
  methods: {
    getProfile() {
      api.getProfile()
      .then((data) => data.data)
      .then((data) => {
          this.$store.dispatch('updateUserInfo', data.data[0])
      })
      .finally(() => {
        this.$vs.loading.close()
        location.href = '/views'
      })
      .catch((e) => {
        console.log(e)
        this.$vs.loading.close()
      });
    },
    getGeneralData() {
      this.$vs.loading()
      api.general()
      .then(result => result.data)
      .then(data => {
        if(data.status) {
          this.$store.dispatch('updateGneralData', data.data[0] != undefined ? data.data[0] : null)
        }
      })
      .finally(() => {
        this.getProfile()
      })
      .catch((e) => {
        console.log(e)
        this.$vs.loading.close()
      });
    },
  }
};
</script>
